module.exports = __webpack_public_path__ + "img/ararat-age-confirm-logo.e0dbbb27.svg";